import React from 'react';
import { LogoMark } from '../components/LogoMark';
export function WhoStrip() {
  return <section className="w-full border-y border-charcoal/10 bg-charcoal" data-id="element-647">
      <div className="mx-auto flex max-w-7xl items-start gap-4 px-5 py-6 lg:px-8" data-id="element-648">
        <LogoMark className="mt-0.5 h-5 w-5 shrink-0" data-id="element-649" />
        <p className="text-sm leading-relaxed text-cream/85 sm:text-base" data-id="element-650">
          <span className="font-bold text-cream" data-id="element-651">Built for the field.</span> For
          mine geologists, senior geologists, geology superintendents and
          technical services teams who want to improve how geology decisions
          actually get made on site — FIFO roster or not.
        </p>
      </div>
    </section>;
}